/* ==========================================================================
   Zapatos Obi — wishlist.js
   Favoritos sin cuenta ni app: se guardan los handles en localStorage.
   - Corazón en tarjetas y ficha: alterna favorito y marca estado.
   - Contador en la cabecera.
   - DRAWER de favoritos (como el carrito): el botón del header lo abre y se
     pintan como lista compacta vía Section Rendering API (?section_id=wishlist-line).
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'obi:wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    updateCount();
    return i === -1; // true = añadido
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
    var label = document.querySelector('[data-wishlist-count-label]');
    if (label) label.textContent = n ? ' (' + n + ')' : '';
  }

  function syncButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- Drawer ---------- */
  var lastFocus = null;

  function drawerEl() {
    return document.querySelector('[data-wishlist-drawer]');
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    renderDrawer();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.documentElement.classList.add('wishlist-drawer-open');
        var closeBtn = document.querySelector('.wishlist-drawer__close');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      });
    });
  }

  function closeDrawer() {
    document.documentElement.classList.remove('wishlist-drawer-open');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  function renderDrawer() {
    var d = drawerEl();
    if (!d) return;
    var items = d.querySelector('[data-wishlist-items]');
    var empty = d.querySelector('[data-wishlist-empty]');
    var loading = d.querySelector('[data-wishlist-loading]');
    var handles = read();

    updateCount();
    if (!items) return;
    items.innerHTML = '';

    if (!handles.length) {
      if (loading) loading.hidden = true;
      items.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    items.hidden = false;
    if (loading) loading.hidden = false;

    var pending = handles.length;
    handles.forEach(function (handle) {
      /* placeholder en orden (conserva el orden de guardado) */
      var ph = document.createElement('div');
      ph.setAttribute('data-wishlist-item', '');
      ph.setAttribute('data-handle', handle);
      ph.className = 'wishlist-line wishlist-line--ph';
      items.appendChild(ph);

      fetch('/products/' + encodeURIComponent(handle) + '?section_id=wishlist-line')
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .then(function (html) {
          var node = null;
          if (html) {
            var tmp = document.createElement('template');
            tmp.innerHTML = html.trim();
            node = tmp.content.querySelector('.wishlist-line');
          }
          if (node) ph.replaceWith(node);
          else ph.remove(); // producto borrado o no disponible
        })
        .catch(function () {
          ph.remove();
        })
        .finally(function () {
          pending--;
          if (pending === 0) {
            if (loading) loading.hidden = true;
            maybeEmptyDrawer();
          }
        });
    });
  }

  function maybeEmptyDrawer() {
    var d = drawerEl();
    if (!d) return;
    var items = d.querySelector('[data-wishlist-items]');
    var empty = d.querySelector('[data-wishlist-empty]');
    if (items && empty && !items.children.length) {
      items.hidden = true;
      empty.hidden = false;
    }
  }

  /* ---------- Delegación de eventos ---------- */
  document.addEventListener('click', function (e) {
    /* abrir / cerrar drawer */
    if (e.target.closest('[data-wishlist-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-wishlist-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    /* corazón (delegado: vale para contenido cargado por AJAX) */
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var added = toggle(handle);
    btn.classList.toggle('is-active', added);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    /* refrescar otros corazones del mismo producto */
    document.querySelectorAll('[data-wishlist-toggle][data-handle="' + handle + '"]').forEach(function (b) {
      if (b === btn) return;
      b.classList.toggle('is-active', added);
      b.setAttribute('aria-pressed', added ? 'true' : 'false');
    });
    /* al quitar, elimina su tarjeta del drawer */
    if (!added) {
      var item = btn.closest('[data-wishlist-item]');
      if (item) {
        item.remove();
        maybeEmptyDrawer();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.documentElement.classList.contains('wishlist-drawer-open')) {
      closeDrawer();
    }
  });

  function init() {
    syncButtons();
    updateCount();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* expuesto para que la colección resincronice tras renders AJAX */
  window.ObiWishlist = { sync: syncButtons, count: updateCount, open: openDrawer };
})();
